import { UseQueryResult, useQuery } from "@tanstack/react-query";
import usePrivateAxios from "@/common/api/usePrivateAxios";
import { CompanyBranchFinancialSummaryData } from "../types/companyBranches.type";

export const useCompanyBranchFinancialSummary: (id: string, enabled?: boolean) => UseQueryResult<CompanyBranchFinancialSummaryData, unknown> = (id, enabled = true) => {
  const privateAxios = usePrivateAxios();

  return useQuery<{ data: { data: CompanyBranchFinancialSummaryData } }, unknown, CompanyBranchFinancialSummaryData>({
    enabled,
    queryKey: ['companyBranchFinancialSummary', id],
    queryFn: () => privateAxios.get(`/client/company_branches/${id}/financial_summary`),
    select: (data) => data?.data?.data,
  })
}
